import React from 'react'
import { Chart } from '@s4l/ds'
import { ListOfPriceDistribution } from '@s4l/stayforlong/property/ListOfPriceDistribution'
import { type UtilityClassNames } from '@s4l/utility-css'

interface IPriceHistogramProps {
  className?: UtilityClassNames
  listOfPriceDistributionJSON: ReturnType<ListOfPriceDistribution['toJSON']>
}
const PriceHistogram = ({ className, listOfPriceDistributionJSON }: IPriceHistogramProps) => {
  const model = ListOfPriceDistribution.fromJSON(listOfPriceDistributionJSON)

  const barColor = model.mapOnRange(
    () => 'var(--color-neutral-400)',
    () => 'var(--color-primary-300)'
  )

  return (
    <Chart.Bar
      scale={model.getScale()}
      data={model.getData()}
      barColor={barColor}
      className={className}
    />
  )
}

PriceHistogram.displayName = 'PriceHistogram'
export default PriceHistogram
